import { render, staticRenderFns } from "./OperaDeviceRoleWindow.vue?vue&type=template&id=5277e92f&"
import script from "./OperaDeviceRoleWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDeviceRoleWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports